module.exports = __webpack_public_path__ + "img/electric_use_selected.0d24d1d3.svg";